export default __webpack_public_path__ + "static/media/mario-evil-pole.a8a428f0.webp";